import { render, staticRenderFns } from "./organization-invite-member.vue?vue&type=template&id=9c2b8556&"
import script from "./organization-invite-member.vue?vue&type=script&lang=js&"
export * from "./organization-invite-member.vue?vue&type=script&lang=js&"
import style0 from "./organization-invite-member.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports